export class MakeTransaction {
    bookingId: number;
    command: TransactionCommand;
        
    constructor() {
        this.command = new TransactionCommand();
    }
}

class TransactionCommand {
    action: string;
    amount: number;
    type: string;
    method: string;
    note: string;
}


// WEBPACK FOOTER //
// ./src/holiday/models/MakeTransaction.ts